import * as yup from "yup";
import { useState } from "react";
import { Trans } from "react-i18next";
import { toast } from "react-toastify";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import Loaing from "../../icons/loaing";
import ConfirmModal from "../ConfirmModal";
import TextArea from "../event-selection/textArea";
import { putFoodsafety } from "../../services/foodsafetyService";
import { closeReporting } from "../../services/dashboardService";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { FoodSafetyPDF } from "./foodsafety-pdf";
import SelectAndQmark from "../event-selection/select&Qmark";
import DeletePopup from "./delete-popup";
import { UPDATE_VALUES } from "../../data/constants";
import moment from "moment";
import FormDateInput from "../FormDateInput";
import AdminWrapper from "../misc/AdminWrapper";

export type updateFoodsafetyTypes = {
  __v: number;
  _id: string;
  reporting: string;
  eventDate: string;
  type: string;
  cause: string;
  actionTaken: string;
  printeventDate: boolean;
  printtype: boolean;
  printcause: boolean;
  printactionTaken: boolean;
  reportingId: string;
  setOpen: (value: boolean) => void;
  updateRecord: (value: any) => void;
  selectedPeriod: string;
};

const schema = yup.object({
  eventDate: yup.string().required(),
  type: yup.string().required(),
  cause: yup.string().required(),
  actionTaken: yup.string().required(),
});

const UpdateFoodSafety: React.FC<updateFoodsafetyTypes> = ({
  reporting,
  reportingId,
  setOpen,
  updateRecord,
  selectedPeriod,
  ...props
}) => {
  const [editEnabled, setEditEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [pdfData, setPdfData] = useState<any>(undefined);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [date, setDate] = useState<string>(
    props.eventDate === "Invalid date" || !props.eventDate
      ? moment(selectedPeriod).format("YYYY-MM-DD")
      : props.eventDate
  );

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<updateFoodsafetyTypes>({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props,
    },
  });

  const handleDownload: SubmitHandler<updateFoodsafetyTypes> = async (data) => {
    data.eventDate = moment(data.eventDate).format("YYYY-MM-DD");
    setPdfData(data);
  };

  const onSubmit: SubmitHandler<updateFoodsafetyTypes> = async (data) => {
    setLoading(true);
    try {
      const {
        printactionTaken,
        printcause,
        printtype,
        printeventDate,
        ...rest
      } = data;
      rest.eventDate = moment(data.eventDate).format("YYYY-MM-DD");
      const response = await putFoodsafety(rest, data._id);

      if (response.message === "updated") {
        updateRecord(response.data);
        toast.success("Your action has been successfully saved!");
        setLoading(false);
        setOpen(false);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };

  const resetForm = () => {
    setConfirmModalVisible(false);
    reset();
  };

  const updateReporting = async (value: string) => {
    setLoading(true);
    try {
      const response = await closeReporting(reportingId, { status: value });
      if (response.message === "updated") {
        updateRecord(response.data);
        toast.success("Your action has been successfully saved!");
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };

  const deleteEvent = (deleteConfirmed: boolean) => {
    if (deleteConfirmed) {
      setOpenDeletePopup(false);
      updateReporting(UPDATE_VALUES.DELETED);
    } else {
      setOpenDeletePopup(false);
    }
  };
  return (
    <section className="relative font-Poppins">
      <AdminWrapper>
        <DeletePopup
          deleteEvent={deleteEvent}
          open={openDeletePopup}
          setOpen={setOpenDeletePopup}
        />
      </AdminWrapper>
      <div>
        <div className="grid gap-3 lg:mx-10">
          <div className="w-16 h-16">
            <img
              src="/images/report.png"
              alt="!"
              className="max-w-full h-auto"
            />
          </div>
          <h1 className="text-4xl font-bold">
            <Trans i18nKey="Food Safety Issues">Food Safety Issues</Trans>
          </h1>
          <p className="text-xl text-[#6B6B6B]">
            <Trans i18nKey="food_safety_description">
              Please note here the details of safety issues, congrats! No need
              to report it. However, for “presence of extraneous material in the
              food”, report the incident only if the material has been in the
              child’s mouth or ingested by the child (if it was found and
              removed before the child has eaten it, congrats! no need to report
              it)
            </Trans>
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-end lg:px-[20px] my-10 gap-[15px]">
          <AdminWrapper>
            {editEnabled && (
              <button
                type="button"
                className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
                onClick={() => setConfirmModalVisible(true)}
              >
                <Trans>Reset</Trans>
              </button>
            )}
            {!editEnabled && (
              <button
                type="button"
                className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
                onClick={() => setEditEnabled(true)}
              >
                <Trans>Edit</Trans>
              </button>
            )}
            <button
              type="button"
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={() => setOpenDeletePopup(true)}
            >
              <Trans>Delete</Trans>
            </button>
            <button
              type="button"
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={() => updateReporting(UPDATE_VALUES.CLOSED)}
            >
              <Trans>Validate</Trans>
            </button>
          </AdminWrapper>
          {pdfData ? (
            <PDFDownloadLink
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              document={<FoodSafetyPDF formData={pdfData} />}
              fileName={"food-safety-issue.pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? "Loading..." : "Download PDF"
              }
            </PDFDownloadLink>
          ) : (
            <button
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={handleSubmit(handleDownload)}
            >
              <Trans>Generate PDF</Trans>
            </button>
          )}
        </div>

        <div className="relative z-0 border border-gray-500 lg:mx-5">
          <div className="absolute -top-3 left-5 lg:-top-5 lg:left-14 bg-[white] px-[20px] lg:px-5">
            <h1 className="text-sm lg:text-3xl font-bold text-[#1E408E]">
              <Trans i18nKey="Event Details">Event Details</Trans>
            </h1>
          </div>
          <div className="md:p-16 sm:p-8 p-4 pt-16">
            <div className="grid gap-5">
              <FormDateInput
                type="Date"
                register={register}
                errors={errors}
                name="eventDate"
                printEnabled
                label="Event date"
                placeholder=""
                translateId="Event date"
                disabled={!editEnabled}
                date={date}
                setDate={setDate}
                control={control}
              />
              <SelectAndQmark
                register={register}
                errors={errors}
                printEnabled
                name="type"
                label="Type"
                options={[
                  "Select",
                  "Choking food parts not removed, Eg. Fishbone",
                  "Foreign objects found in food",
                  "Hot food burn",
                  "Food Contamination due to mishandling",
                  "Bacteria from food source",
                  "Other serious case",
                ]}
                translateId="Type"
                disabled={!editEnabled}
                i18nKey="Help Box - Food Safety Issue - Food safety issues"
              />
              <TextArea
                register={register}
                errors={errors}
                printEnabled
                name="cause"
                label="Cause"
                translateId="Cause"
                disabled={!editEnabled}
              />
              <TextArea
                register={register}
                errors={errors}
                name="actionTaken"
                printEnabled
                label="Actions Taken"
                translateId="actionTaken"
                disabled={!editEnabled}
              />
            </div>
          </div>
        </div>
        <AdminWrapper>
          <div className="flex justify-end lg:px-[20px] my-10">
            <button
              type={"submit"}
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
            >
              <Trans i18nKey="Submit">Submit</Trans>
            </button>
            {loading && <Loaing />}
          </div>
        </AdminWrapper>
      </form>
      <ConfirmModal
        isOpen={confirmModalVisible}
        setIsOpen={setConfirmModalVisible}
        onConfirm={resetForm}
      />
    </section>
  );
};

export default UpdateFoodSafety;
